import { render, staticRenderFns } from "./TransactionOrders.vue?vue&type=template&id=34f1c1b2&scoped=true"
import script from "./TransactionOrders.vue?vue&type=script&lang=js"
export * from "./TransactionOrders.vue?vue&type=script&lang=js"
import style0 from "./TransactionOrders.vue?vue&type=style&index=0&id=34f1c1b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f1c1b2",
  null
  
)

export default component.exports